import billing from './billing'
import support from './support'
import user from './user'

export default {
    billing,
    support,
    user
}